export default {
  computed: {
    isAnonymous() {
      return window.CentralStore.state.isAnonymous;
    }
  },
  created() {
    window.CentralStore.setIsAnonymous(true);
  }
};
